import { Typography } from '@mui/material';
import classNames from 'classnames';

import { News } from '../../../../lib/models/news';
import { getLimitedText, getTimeDiffFromNow } from '../../../../lib/util/DataHelpers';

import useIsMobile from '../../../hooks/useIsMobile';

import styles from './NewsCard.module.scss';

/** Below this the card fills the viewport instead of insetting itself. */
const MIN_INSET_WIDTH = 360;
const MOBILE_HORIZONTAL_INSET = 64;
const EXTENDED_HEADLINE_LIMIT = 160;
const HEADLINE_LIMIT = 55;

type Props = {
  item: News;
  isExtended?: boolean;
  /** Analytics hook: the consuming app decides which event a headline click raises. */
  onCardClick?: (headline: string) => void;
};

const NewsCard = ({ item, isExtended, onCardClick }: Props): JSX.Element => {
  const { headline, source, dateTime, image, url } = item;
  const { isMobile } = useIsMobile();

  return (
    <a
      href={url}
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => onCardClick?.(headline)}
      className={styles.link}
    >
      <div
        className={styles.card}
        style={isMobile && window.innerWidth > MIN_INSET_WIDTH
          ? { width: `${window.innerWidth - MOBILE_HORIZONTAL_INSET}px` }
          : {}}
      >
        <div className={styles.wrapperImg}>
          <div
            className={classNames(styles.img, { [styles.imgExtended]: isExtended && !isMobile })}
            style={{ backgroundImage: `url(${image})` }}
          />
        </div>
        <div className={styles.dataWrapper}>
          <p className={styles.meta}>
            {source}
            <span>{getTimeDiffFromNow(dateTime)}</span>
          </p>
          <Typography className={isMobile ? styles.titleMobile : styles.title}>
            {getLimitedText(headline, isExtended && !isMobile ? EXTENDED_HEADLINE_LIMIT : HEADLINE_LIMIT)}
          </Typography>
        </div>
      </div>
    </a>
  );
};

export default NewsCard;
